<template>
  <v-card class="center pa-2" max-width="600" flat>
    <v-card-text>
      <p class="headline align-center mb-5">{{ $t('rooms.errorGetInformation.title') }}</p>
      <div class="align-center my-5">
        <span>{{ $t('rooms.errorGetInformation.text1') }}</span>
        <span>{{ $t('rooms.errorGetInformation.text2') }}</span>
      </div>
      <div v-if="authenticated" class="btn-block">
        <v-btn class="ma-2" color="primary" @click="backToRoom">{{ $t('rooms.buttons.backList') }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ErrorShootingInformations',

  props: {
    authenticated: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    backToRoom() {
      this.$emit('back-room')
    }
  }
}
</script>

<style lang="sass" scoped>
.center
    margin: 20px auto 0 auto

.align-center
    text-align: center

.btn-block
    display: flex
    justify-content: center

.btn-block-col
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
</style>
